import { Dispatch } from 'redux';
import { setPepperUploadDate } from 'modules/cm/store/cases/readonlyFields/actions';
import { mapPepperUploadDate } from 'modules/cm/mapper/Case/ReadonlyFields/mapper';
import { Nullable } from 'utils/types';

const exportFunc = (date: Nullable<string>) => {
  return async (dispatch: Dispatch) => {
    dispatch(setPepperUploadDate(mapPepperUploadDate(date)));
  };
};

export default exportFunc;
